var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.91 60.09A11.09 11.09 0 1 1 60 49a11.1 11.1 0 0 1-11.09 11.09Zm0-20.18A9.09 9.09 0 1 0 58 49a9.11 9.11 0 0 0-9.09-9.09ZM38 60H16a9 9 0 0 1-9-9 18 18 0 0 1 18-18h14a18.12 18.12 0 0 1 5.29.79 1 1 0 1 1-.58 1.91A16.23 16.23 0 0 0 39 35H25A16 16 0 0 0 9 51a7 7 0 0 0 7 7h22a1 1 0 0 1 0 2Zm11-5a1 1 0 0 1-1-1v-4h-4a1 1 0 0 1 0-2h4v-4a1 1 0 0 1 2 0v4h4a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-1 1ZM32 30a13 13 0 1 1 13-13 13 13 0 0 1-13 13Zm0-24a11 11 0 1 0 11 11A11 11 0 0 0 32 6Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCustomer);
export default __webpack_public_path__ + "static/media/new-customer.56962961ec6fb5e91e27008dd0949057.svg";
export { ForwardRef as ReactComponent };